export const environment = {
    production: true,
    env: 'staging',
    authUsername: "way-web-consumer",
    authPassword: "way-web-consumer-secret-test",
    wayadmin: "https://wayplusndppstg.way.com/way-admin/v1/",
    wayauth: "https://wayplusndppstg.way.com/way-auth/",
    ndppwayauth: "https://wayplusndppstg.way.com/way-auth/",
    wayndppadmin: "https://wayplusndppstg.way.com/ndpp-admin/v1/",
    wayAdminConsumerUrl: 'https://wayplusndppstg.way.com/way-consumer/',
    adminBaseUrl: 'https://wayplusndppstg.way.com/',
    stripeKey: "pk_test_OGcsrZkKiCKUPjqjftrhnJt8",
    googleMapsApiKey: "AIzaSyBoNnABvssy1fuVBzsG6OwdE5JNUbESlsE",
    radarPublishableKey: 'prj_test_pk_3b4e23843fb556b01ea21823e81d56068647bf28',
    radarCountryCode: 'US',
    radarMapStyle: '4c96cf07-af51-4e8f-85bd-86cfabfd9e79',
    s3ConfigUrl: 'https://way-images.s3.us-west-1.amazonaws.com/ui-config-testing.json'
};